/** @format */

import React from "react";
import FooterLinks from "./FooterLinks";
import FooterTitle from "./FooterTitle";
import { Logo } from "./Logo";

const FooterSection = () => {
  return (
    <div>
      <div className="flex lg:flex-row flex-col justify-center lg:space-x-14  md:items-center lg:items-start  items-start pb-[30px]">
        <div className="flex flex-col">
          <Logo />
          <p className="font-semibold text-[14px] leading-[19.1px] text-white -mt-2 lg:w-[60%] lg:mb-0 mb-14">
            SideHustle HQ 12, Nigeria, All Rights Reserved
          </p>
        </div>
        <div className="flex sm:flex-row md:flex-wrap xs:flex-col sm:space-x-28 sm:space-y-0 space-y-12">
          <div>
            <FooterTitle title="Links" />
            <FooterLinks>
              <h5>Blogs</h5>
              <h5>Social Media</h5>
              <h5>Counters</h5>
            </FooterLinks>
          </div>
          <div>
            <FooterTitle title="Company" />
            <FooterLinks>
              <h5>Terms & Conditions</h5>
              <h5>Privacy Policy</h5>
              <h5>Contact</h5>
            </FooterLinks>
          </div>
          <div>
            <FooterTitle title="Get in touch" />
            <FooterLinks>
              <h5>SideHustle HQ Nigeria</h5>
              <h5>09039326375</h5>
              <h5>fitstats2@gmail.com</h5>
            </FooterLinks>
          </div>
        </div>
      </div>
    </div>
  );
};

export default FooterSection;
